export default __webpack_public_path__ + "static/404-4a7b148ed215e864ea122a566263231a.png";